<a mat-button color="{{ color }}"
   [disabled]="disabled"
   (click)="export()"
   target="_blank"
   rel="noopener noreferrer"
   data-cy="export-application-btn"
>
  <mat-icon>{{ icon }}</mat-icon> {{ getButtonText() }}
</a>
